import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { bootstrapPaymentReturn } from '@/shared/lib/paymentReturnBootstrap'
import {
  cleanPaymentReturnSearch,
  consumePspReturnPending,
  readCheckoutOutcome,
  readWindowPathname,
  readWindowSearchRecord,
} from '@/shared/lib/paymentReturnHandler'
import { resolvePaymentReturnToastKey } from '@/shared/lib/paymentReturnToast'
import { useToast } from '@/shared/hooks/useToast'

/**
 * Global PSP return UX: refresh CSRF, show contextual toasts, strip query params.
 * Never triggers logout - payment cancel/success must stay authenticated.
 */
export function PaymentReturnNotifications() {
  const { t } = useTranslation()
  const toast = useToast()
  const handledKeyRef = useRef('')

  useEffect(() => {
    const pathname = readWindowPathname()
    const record = readWindowSearchRecord()
    const outcome = readCheckoutOutcome(record)
    if (outcome === null && typeof record.checkout_session_id !== 'string') {
      return
    }

    const key = `${pathname}:${JSON.stringify(record)}`
    if (handledKeyRef.current === key) {
      return
    }
    handledKeyRef.current = key

    void bootstrapPaymentReturn().then(() => {
      const toastKey = resolvePaymentReturnToastKey(pathname, outcome)
      if (toastKey !== null) {
        toast.showToast({ kind: 'info', title: t(toastKey) })
      }

      consumePspReturnPending()
      const cleaned = cleanPaymentReturnSearch(record)
      const query = new URLSearchParams()
      for (const [key, value] of Object.entries(cleaned)) {
        if (value !== undefined && value !== null && value !== '') {
          query.set(key, String(value))
        }
      }
      const suffix = query.toString()
      window.history.replaceState({}, '', suffix === '' ? pathname : `${pathname}?${suffix}`)
    })
  }, [t, toast])

  return null
}
